import React, { useState } from 'react';
import template from 'lodash/template';
import { TWebConfig } from '../types/webconfig';
import { TLocale } from '../types/locale';

// Not sure if this is a good idea 👇
type TChildren = {
    children: JSX.Element | Element;
};

type TProps = {
    webConfig: TWebConfig;
    locale: TLocale;
};

type TAppContext = {
    isSideNavOpen: boolean;
    isSlidingOptionsPanelOpen: Record<string, boolean>;
    toggleSideNav: () => void;
    toggleSlidingOptionsPanel: (slidingPanelId: string, forceClose?: boolean) => void;
    getCdnPath: (path: string) => string;
};

export const AppContext = React.createContext({} as TAppContext & TProps);

export const AppContextProvider = ({ children, locale, webConfig }: TProps & TChildren): React.ReactElement => {
    const [isSideNavOpen, setIsSideNavOpen] = useState(false);
    const [isSlidingOptionsPanelOpen, setIsSlidingOptionsPanelOpen] = useState({});

    const toggleSideNav = (): void => {
        setIsSideNavOpen(!isSideNavOpen);
    };

    const toggleSlidingOptionsPanel = (slidingPanelId: string, forceClose = false): void => {
        setIsSlidingOptionsPanelOpen({
            ...isSlidingOptionsPanelOpen,
            [slidingPanelId]: !forceClose && !isSlidingOptionsPanelOpen?.[slidingPanelId],
        });
    };

    const getCdnPath = (path: string) => {
        const cdnTemplate = webConfig.cdn['cms-v1'];
        const compileFromCdnTemplate = template(cdnTemplate);

        return compileFromCdnTemplate({ path });
    };

    const appContextValue: TAppContext & TProps = {
        webConfig,
        locale,
        isSideNavOpen,
        isSlidingOptionsPanelOpen,
        toggleSideNav,
        toggleSlidingOptionsPanel,
        getCdnPath,
    };

    return <AppContext.Provider value={appContextValue}>{children}</AppContext.Provider>;
};

export default TAppContext;
